import {
  createUserWithEmailAndPassword,
  GoogleAuthProvider,
  sendEmailVerification,
  signInWithPopup,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { toast } from "react-toastify";

import { ensureDashboardToken, registerToSacco } from "./apiCalls";
import { clearDashboardApiToken } from "./apiSessionService";
import { auth, db } from "./firebase";
import { appNavigate } from "./navigationService";
import {
  fetchSaccoMemberByEmail,
  invalidateSaccoMemberCache,
} from "./saccoMemberService";
import { updateSessionSaccoUser } from "./sessionRefresh";
import { apiErrorHandler } from "../utilities/utitlityFunctions";

const actionCodeSettings = {
  url: window.location.origin + "/",
  handleCodeInApp: true,
};

function handleAuthError(code, message = "") {
  switch (code) {
    case "auth/wrong-password":
      return toast.error("Incorect Password");
    case "auth/user-not-found":
      return toast.error("User with provided email does not exist");
    case "WEAK_PASSWORD : Password should be at least 6 characters":
      return toast.error("Password should be at least 6 characters");
    default:
      return toast.error(message);
  }
}

export async function saccoUserRegistration(saccoUser) {
  const _userName = saccoUser.displayName
    ? saccoUser.displayName.split(" ")
    : [];

  const currentUser = {
    email: saccoUser.email,
    firstName: saccoUser.displayName ? _userName[0] : "",
    id: "",
    idNumber: "",
    isVerified: false,
    lastName: saccoUser.displayName ? _userName[_userName.length - 1] : "",
    matatuList: [],
    photo: saccoUser.photoURL || "",
    role: "",
    sacco: saccoUser.sacco,
  };

  try {
    await ensureDashboardToken();
    const _res = await registerToSacco(currentUser);
    if (_res?.payload?.status === "success") {
      toast.success(_res.payload.message);
      invalidateSaccoMemberCache();
      const refreshed = await fetchSaccoMemberByEmail(db, saccoUser.email);
      updateSessionSaccoUser(refreshed);
      appNavigate("/profile", { replace: true });
      return;
    }
    toast.error(
      _res?.payload?.message ||
        _res?.message ||
        "Could not complete Sacco registration.",
    );
    appNavigate("/sacco/account/register", { replace: true });
  } catch (_err) {
    toast.error("Sorry an error occured creating profile.");
    appNavigate("/sacco/account/register", { replace: true });
  }
}

export const emailSignIn = (email, password) => {
  signInWithEmailAndPassword(auth, email, password)
    .then(() => {
      //console.log("user: ", userCredential.user);
    })
    .catch((error) => {
      handleAuthError(error.code);
    });
};

const googleProvider = new GoogleAuthProvider();

export function signInWithGoogle(register = false) {
  signInWithPopup(auth, googleProvider)
    .then(async function (result) {
      const user = result.user;
      if (register) await saccoUserRegistration(user);
    })
    .catch(function (error) {
      apiErrorHandler(error);
    });
}

export const signUpWithGoogle = () => {
  signInWithGoogle(true);
};

export function emailSignUp(email, password) {
  createUserWithEmailAndPassword(auth, email, password)
    .then(async function (userCredentials) {
      if (userCredentials) {
        const user = userCredentials.user;
        sendEmailVerification(user, actionCodeSettings)
          .then(function () {
            document
              .getElementById("signup-complete")
              ?.classList.remove("d-none");
            document
              .getElementById("signup-component")
              ?.classList.add("d-none");
          })
          .catch(function (err) {
            console.error(err);
          });
        await saccoUserRegistration(user);
      }
    })
    .catch(function (err) {
      handleAuthError(err.code, err.message);
    });
}

export const logout = () => {
  signOut(auth)
    .then((_e) => {
      clearDashboardApiToken();
      appNavigate("/login", { replace: true });
    })
    .catch((_err) => {
      toast.error("Failed to log out, please try again.");
    });
};
